<template>
  <a-card>
    <div :class="advanced ? 'search' : null">
      <a-form layout="inline" class="searchForm">
        <a-form-item label="角色名称" :labelCol="{ span: 5 }" :wrapperCol="{ span: 18, offset: 1 }" style="width: 300px">
          <a-input :maxLength="30" placeholder="请输入" @keyup.enter="getList(1)" v-model.trim="searchForm.roleName" />
        </a-form-item>
        <a-form-item label="角色类型" :labelCol="{ span: 5 }" :wrapperCol="{ span: 18, offset: 1 }" style="width: 300px">
          <a-select placeholder="请选择" v-model="searchForm.roleType" allowClear>
            <a-select-option :value="0">平台角色</a-select-option>
            <a-select-option :value="1">机构内置角色</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="角色组" :labelCol="{ span: 5 }" :wrapperCol="{ span: 18, offset: 1 }" style="width: 300px">
          <a-select placeholder="请选择" v-model="searchForm.roleGroup" allowClear>
            <a-select-option :value="0">超级管理员</a-select-option>
            <a-select-option :value="1">管理员</a-select-option>
            <a-select-option :value="2">教师</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item style="margin-right: 35px">
          <a-button type="primary" @click="getList(1)">查询</a-button>
          <a-button style="margin-left: 8px" @click="resetSearch()">重置</a-button>
        </a-form-item>
        <a-form-item>
          <a-button v-permission="`Auth.Role.Add`" @click="addNew" icon="plus" type="primary">添加角色</a-button>
          <a-button v-permission="`Auth.Role.DeleteAll`" @click="batchDelete" type="danger" icon="delete" style="margin-left: 15px">批量删除 </a-button>
        </a-form-item>
      </a-form>
    </div>
    <div style="margin-top: 15px">
      <a-table
        :columns="columns"
        rowKey="id"
        :pagination="tableRelevant.tablePagination"
        :loading="tableRelevant.tableLoading"
        :locale="tableRelevant.locale"
        :dataSource="tableRelevant.tableDataSource"
        :row-selection="rowSelection"
      >
        <div slot="roleType" slot-scope="text, record">
          {{ ['平台角色', '机构内置角色'][record.roleType] }}
        </div>
        <div slot="roleGroup" slot-scope="text, record">
          {{ ['超级管理员', '管理员', '教师'][record.roleGroup] }}
        </div>
        <div slot="action" slot-scope="text, record">
          <div v-if="text.roleGroup === 0">-</div>
          <div v-else>
            <a v-permission="`Auth.Role.Edit`" @click="edit(text)" style="margin-right: 8px">
              <a-icon type="edit" />
              编辑
            </a>
            <a-popconfirm title="确定删除？" v-permission="`Auth.Role.Delete`" ok-text="确定" cancel-text="取消" @confirm="deleteRecord(text)">
              <a style="color: #f00; margin-right: 8px">
                <a-icon type="delete" />
                删除
              </a>
            </a-popconfirm>
            <a-dropdown>
              <a class="ant-dropdown-link" @click="(e) => e.preventDefault()">
                更多
                <a-icon type="down" />
              </a>
              <a-menu slot="overlay">
                <!-- v-permission="`/settings/Roles/Deploy`" -->
                <a-menu-item v-permission="`/settings/Roles/Deploy`">
                  <a  @click="deploy(text)"> 功能权限 </a>
                </a-menu-item>
                <a-menu-item v-permission="`/settings/Roles/dataAuthority`">
                  <a @click="dataAuthority(text)">数据权限</a>
                </a-menu-item>
              </a-menu>
            </a-dropdown>
          </div>
        </div>
      </a-table>
    </div>
    <a-modal v-model="addvisible" :title="addTitle" @ok="handleOk" @cancel="handleCancel">
      <a-form-model ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item ref="name" label="角色名称" prop="name">
          <a-input
            @change="(e) => (form.name = e.target.value.replace(/\s*/g, ''))"
            v-model="form.name"
            placeholder="请输入角色名称"
            @blur="
              () => {
                $refs.name.onFieldBlur()
              }
            "
          />
        </a-form-model-item>
        <a-form-model-item label="角色类型" prop="roleType">
          <a-select placeholder="请选择角色类型" v-model="form.roleType">
            <a-select-option :value="0">平台角色</a-select-option>
            <a-select-option :value="1">机构内置角色</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="角色组" prop="roleGroup">
          <a-select placeholder="请选择角色组" v-model="form.roleGroup">
            <a-select-option :value="1">管理员</a-select-option>
            <a-select-option :value="2">教师</a-select-option>
          </a-select>
        </a-form-model-item>
        <!-- <a-form-model-item ref="roleRank" label="角色等级">
          <a-input-number
            @change="(e) => (form.roleRank = e.target.value.replace(/\s*/g, ''))"
            style="width: 100%"
            v-model="form.roleRank"
            placeholder="请输入角色等级"
            @blur="
              () => {
                $refs.roleRank.onFieldBlur()
              }
            "
          />
        </a-form-model-item> -->
        <a-form-model-item ref="organizationId" label="机构名称" prop="organizationId" v-if="isOrg">
          <a-select show-search placeholder="输入机构名称查询" v-model="form.organizationId" :filter-option="filterOption">
            <a-select-option :value="item.id" v-for="item in orgList" :key="item.id">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item ref="remark" label="角色描述" prop="remark">
          <a-input v-model="form.remark" placeholder="请输入角色描述" :maxLength="200" type="textarea" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </a-card>
</template>

<script>
import { tableRelevant } from '@/pages/projectImpl/js/utils'

const columns = [
  {
    title: '角色名称',
    dataIndex: 'name',
    align: 'center',
  },
  {
    title: '角色类型',
    scopedSlots: { customRender: 'roleType' },
    align: 'center',
  },
  {
    title: '角色组',
    scopedSlots: { customRender: 'roleGroup' },
    align: 'center',
  },
  {
    title: '角色描述',
    align: 'center',
    dataIndex: 'remark',
    ellipsis: true,
    scopedSlots: { customRender: 'remark' },
  },
  {
    title: '更新时间',
    align: 'center',
    dataIndex: 'updateTime',
  },
  {
    title: '操作',
    align: 'center',
    scopedSlots: { customRender: 'action' },
  },
]

export default {
  name: 'Roles',
  data() {
    const checkName = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入角色名称!'))
      } else {
        if (!/^[\u4e00-\u9fa5]+$/.test(value)) {
          callback(new Error('请输入汉字!'))
        } else {
          callback()
        }
      }
    }
    return {
      advanced: false,
      columns: columns,
      loading: true,
      tableRelevant: tableRelevant.call(this, this.getList),
      checkedList: [],
      searchForm: {
        roleName: undefined,
        roleType: undefined,
        roleGroup: undefined,
      },
      addvisible: false,
      ClientApplicationId: '', //应用ID
      istoggleAdvanced: false, //是否显示展开按钮

      editvisible: false,
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
      other: '',
      addTitle: '添加角色',
      form: {
        name: '',
        remark: '',
        roleType: undefined,
        roleGroup: undefined,
        id: undefined,
        roleRank: undefined,
        organizationId: undefined,
        enabled: true,
      },
      rules: {
        organizationId: [{ required: true, message: '请选择机构', trigger: 'change' }],
        roleType: [{ required: true, message: '请选择角色类型', trigger: 'change' }],
        roleGroup: [{ required: true, message: '请选择角色组', trigger: 'change' }],
        name: [
          { required: true, message: '请输入角色名称', trigger: 'blur' },
          { min: 2, max: 20, message: '角色名称长度为 2 到 20 个字符', trigger: 'blur' },
        ],
        roleRank: [{ required: true, message: '请输入角色等级', trigger: 'blur' }],
      },
      isOrg: false,
      orgList: [],
    }
  },
  watch: {
    'form.roleType'(newValue, oldValue) {
      console.log(newValue)
      if (newValue == 3) {
        this.isOrg = true
      } else {
        this.isOrg = false
      }
    },
  },
  computed: {
    rowSelection() {
      return {
        selectedRowKeys: this.checkedList,
        onChange: (selectedRowKeys, selectedRows) => {
          this.checkedList = selectedRowKeys
        },
        getCheckboxProps: (record) => ({
          props: {
            disabled: record.name === '超级管理员',
          },
        }),
      }
    },
  },
  created() {
    this.getList()
    this.getOrgList()
  },
  activated() {
    this.getList()
  },
  methods: {
    dataAuthority(record) {
      this.$router.push({
        path: '/settings/Roles/dataAuthority',
        query: {
          roleId: record.id,
          roleType: record.roleType,
        },
      })
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    getList(pageIndex) {
      let params = {
        pageIndex: pageIndex || this.tableRelevant.tablePagination.current,
        pageSize: this.tableRelevant.tablePagination.pageSize,
        ...this.searchForm,
      }
      this.tableRelevant.tableLoading = true
      this.checkedList = []
      this.$http.roleList(params).then((res) => {
        this.tableRelevant.tableLoading = false
        const { data } = res.data
        this.tableRelevant.tableDataSource = data.items
        this.tableRelevant.tablePagination.total = data.totalCount
        this.tableRelevant.tablePagination.current = data.pageIndex
      })
    },
    resetSearch() {
      this.RoleName = ''
      this.RoleType = undefined
      this.searchForm = {}
      this.getList(1)
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    onSelectChange(keys, rows) {
      this.checkedList = keys
    },
    addNew() {
      this.form = {
        name: '',
        remark: '',
        roleType: undefined,
        id: undefined,
        organizationId: undefined,
        enabled: true,
      }
      this.addTitle = '新增角色'
      this.addvisible = true
    },
    getOrgList() {
      let params = {
        pageIndex: 1,
        pageSize: 99999,
      }
      this.$http.getOrgList(params).then((res) => {
          localStorage.setItem('orgList', JSON.stringify(res.data.data.items))
          this.orgList = res.data.data.items
      
      })
    },
    // 删除
    deleteRecord(record) {
      // let params = this.checkedList
      let params = [record.id]
      this.$http.deleteRole(params).then((res) => {
          this.getList(1)
          this.$message.success('删除成功')
       
      })
    },
    // 批量删除
    batchDelete() {
      const that = this
      if (this.checkedList.length) {
        this.$confirm({
          title: '确认删除选中的角色？',
          okType: 'danger',
          centered: true,
          onOk() {
            let params = that.checkedList
            that.$http.deleteRole(params).then((res) => {
                that.getList(1)
                that.$message.success('删除成功')
                that.checkedList = []
             
            })
          },
        })
      } else {
        this.$message.destroy()
        this.$message.warning('请选择角色')
      }
    },
    handleOk() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          const Ajax = this.addTitle === '编辑角色' ? this.$http.updateRole : this.$http.addRole
          Ajax(this.form).then((res) => {
              this.addvisible = false
              this.getList()
              this.$message.success('添加成功')
              this.resetForm()
           
          })
        } else {
          console.log('error submit!!')
        }
      })
    },
    resetForm() {
      this.form.name = ''
      this.form.remark = ''
    },
    handleCancel() {
      this.$refs.ruleForm.resetFields()
    },
    onPageChange(pageIndex, size) {
      this.pageIndex = pageIndex
      this.getList()
    },
    onSizeChange(pageIndex, size) {
      this.pageIndex = 1
      this.pageSize = size
      this.getList()
    },
    // 编辑
    edit(row) {
      for (let key in this.form) {
        this.form[key] = row[key]
      }
      this.addTitle = '编辑角色'
      this.addvisible = true
    },
    // 权限配置
    deploy(row) {
      this.$router.push({
        path: '/settings/Roles/Deploy',
        query: {
          id: row.id,
          name: row.name,
          organizationId: row.organizationId,
          roleType: row.roleType,
        },
      })
    },
  },
}
</script>

<style lang="less" scoped>
.search {
  margin-bottom: 54px;
}

.fold {
  width: calc(100% - 216px);
  display: inline-block;
}

.operator {
  margin-bottom: 18px;
}

/deep/ .standard-table .alert {
  display: none !important;
}

.searchForm {
  display: flex;
  /deep/ .fold {
    width: 22%;
    display: flex;
  }
}

@media screen and (max-width: 900px) {
  .fold {
    width: 100%;
  }
}
</style>
